// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__2PFNY","logo":"MainNavigation_logo__nZRrx","nav":"MainNavigation_nav__2nJ6O","active":"MainNavigation_active__OHmAY"};